// extracted by mini-css-extract-plugin
export default {"selected":"styles_selected__lzAIF","unselected":"styles_unselected__4P52q"};